import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/service/loader.service';
import { SideImageLandingComponent } from '../side-image-landing/side-image-landing.component';
import { RegisterformLandingComponent } from '../registerform-landing/registerform-landing.component';
import { CommonModule } from '@angular/common';
import { FooterLandingComponent } from '../footer-landing/footer-landing.component';

@Component({
  selector: 'app-afisure-landing',
  templateUrl: './afisure-landing.component.html',
  styleUrls: ['./afisure-landing.component.scss'],
  standalone:true,
  imports:[
    SideImageLandingComponent,
    RegisterformLandingComponent,
    FooterLandingComponent,

  ]
})
export class AfisureLandingComponent{
  }
